import React, { useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from 'react'
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../../store/recoil/tenant/atoms';
import useGetCustomerName from '../../../hooks/useGetCustomerName';
import { OptionModel } from '../../../common/types/OptionModel';
import { useDispatch, useSelector } from 'react-redux';
import { updateIsResetForm } from '../../../store/slices/formHelperSlice';
import commonNetwork from '../../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import { Form, Formik } from 'formik';
import FormFiltersShortList from '../FormElements/FormFiltersShortList';
import { Button } from '../Elements';
import { buttonTexts } from '../../../constants/texts/buttonTexts';
import { getSelectedValueFromId } from '../../../common/helpers/selectBoxHelper';
import { FormCheckbox, FormDateSelector, FormInput, FormSelector } from '../FormElements';
import AmountRange from '../AmountRange';
import { getUserIdentity } from '../../../common/helpers/authorizationHelper';
import FormObserver from '../FormElements/FormObserver';
import { FilterProps } from '../../../common/types/FilterProps';
import { errorMessages } from '../../../constants/messages/errorMessages';
import { getOrderInstallmentsReport } from '../../../store/slices/orderInstallmentsReportSlice';
import { getOrderInstallmentsReportByVp } from '../../../store/slices/orderInstallmentsReportPerVpSlice';
import { parseTurkishFloat } from '../../../common/helpers/parseTurkishFloat';

const isTestOptions = [
    {
        value: false,
        label: "Canlı Ortam"
    },
    {
        value: true,
        label: "Test Ortam"
    }
]

const Filters = React.forwardRef<HTMLDivElement | any, FilterProps>(({ isOpen, setFiltersIsOpen, setIsDetail, setTotalAmountCurrency }, ref) => {

    const initialValues = {
        customerId: 0,
        customerNameOrCode: "",
        taxCode: "",
        bankId: 0,
        orderCode: "",
        currencyId: 0,
        dateRange: {
            startDate: null,
            endDate: null,
        },
        amountRange: {
            start: 0,
            end: 0,
        },
        isTest: false,
        cardFirstPart: "",
        cardLastPart: "",
        showDetail: false,
    };

    useImperativeHandle(ref, () => ({

        submitform() {
            submitform();
        }
    }));

    const { firmInformations } = useRecoilValue(tenantState);
    const currencySelectList = useSelector((state: any) => state.firmCurrencyList.currencyListForSelect);
    const formref = useRef<any>();
    const dateRangeRef = useRef<any>();
    const isInitialRequest = useRef(true);

    const [formValues, setFormValues] = useState(initialValues);
    const [customerOptions, setCustomerOptions] = useState<OptionModel[]>([]);
    const [loadingCustomer, setLoadingCustomer] = useState<boolean>(false);
    const [posList, setPosList] = useState([]);
    const [isDealer, setIsDealer] = useState<boolean>(false);

    const dispatch = useDispatch<any>();

    useLayoutEffect(() => {

        selectPos();

    }, []);

    useEffect(() => {
        handleUserIdentity();
        selectOrderInstallmentsList();
    }, []);

    useGetCustomerName(setCustomerOptions, setLoadingCustomer);

    useEffect(() => {
      setTotalAmountCurrency(formValues.currencyId);
    }, [formValues.currencyId])
    

    const selectPos = async () => {

        const data = await commonNetwork.get("/virtualpos");
        var poslist: any = [];
        if (data.isSuccess) {
            var res = data.data.data;
            poslist.push({
                value: 0,
                label: "Tümü",
            });
            for (let i = 0; i < res.length; i++) {
                const element = res[i];
                poslist.push({
                    value: element.vpid,
                    label: element.vpdisplayname ? element.vpdisplayname : element.bankname,
                });
            }
            setPosList(poslist);

        } else {
            toast.error(data.errorMessage);
        }
    }

    const selectOrderInstallmentsList = () => {
        if (formref && formref.current) {
            formref.current.submitForm();
        }
    }

    function submitform() {
        formref.current.submitForm();
    }

    const onSubmit = async (values: any) => {

        if (parseTurkishFloat((formValues.amountRange.start || 0).toString()) > parseTurkishFloat((formValues.amountRange.end || 0).toString()) && formValues.amountRange.end !== 0) {
            toast.error(errorMessages.lowEndAmountRange);
        } else {
            var start = values.dateRange.startDate;
            var end = values.dateRange.endDate;

            var startDate = "";
            var endDate = "";
            if (start) {
                startDate = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear();
            }
            if (end) {
                endDate = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear();
            }

            let parameters;

            if (values.showDetail) {
                parameters = {
                    customerId: values.customerId,
                    customerNameOrCode: values.customerNameOrCode,
                    taxCode: values.taxCode,
                    bankId: values.bankId,
                    orderCode: values.orderCode,
                    currencyId: values.currencyId,
                    paymentStartDate: startDate,
                    paymentEndDate: endDate,
                    paymentStartAmount: values.amountRange.start,
                    paymentEndAmount: values.amountRange.end,
                    cardFirstPart: values.cardFirstPart,
                    cardLastPart: values.cardLastPart
                };
                dispatch(getOrderInstallmentsReport(parameters));
                setIsDetail(true);
            } else {
                parameters = {
                    paymentStartDate: startDate,
                    paymentEndDate: endDate,
                    bankId: values.bankId,
                    paymentStartAmount: values.amountRange.start,
                    paymentEndAmount: values.amountRange.end,
                    currencyId: values.currencyId
                };
                dispatch(getOrderInstallmentsReportByVp(parameters));
                setIsDetail(false);
            }
        }

        if (isInitialRequest.current) {
            isInitialRequest.current = false;
        } else {
            setFiltersIsOpen(false);
        }
    }

    const clearFilters = () => {
        dispatch(updateIsResetForm(true));
        setTimeout(() => {
            dispatch(updateIsResetForm(false));
        }, 1000);

        formref.current.resetForm();
        submitform();
    };

    const resetDateRanges = (value: any) => {
        var keys = Object.keys(value);

        if (keys && keys.length > 0) {
            if (keys[0] == "dateRange") {
                dateRangeRef.current.resetForm();
            }
        }
    }

    const onUpdate = (value: any) => {
        setFormValues(Object.assign(formValues, value));
        resetDateRanges(value);
        submitform();
    };

    const handleUserIdentity = () => {
        switch (getUserIdentity()) {
            case "BAYİ/MÜŞTERİ":
            case "ALTBAYİ":
            case "MÜŞTERİ TEMSİLCİSİ":
                setIsDealer(true);
                break;
            default:
                setIsDealer(false);
                break;
        }
    }

    const fields = [
        // {
        //     key: "customerId",
        //     label: "Alıcı Ünvan / Ad Soyad",
        //     type: "select",
        //     options: customerOptions
        // },
        {
            key: "customerNameOrCode",
            label: "Cari Hesap Ünvan / Cari Kod",
            type: "text"
        },
        {
            key: "dateRange",
            label: "Tarih Aralığı",
            type: "object",
            datatype: "daterange"
        },
        {
            key: "taxCode",
            label: "VKN/TCKN",
            type: "text"
        },
        {
            key: "bankId",
            label: "Ödeme Altyapısı",
            type: "select",
            options: posList
        },
        {
            key: "isTest",
            label: "Ödeme Ortamı",
            type: "select",
            options: isTestOptions,
        },
        {
            key: "orderCode",
            label: "Sipariş Kodu",
            type: "text"
        },
        {
            key: "amountRange",
            label: "Bakiye Aralığı",
            type: "object",
            datatype: "moneyrange"
        },
        {
            key: "cardFirstPart",
            label: "Kart İlk 4 Hane",
            type: "text"
        },
        {
            key: "cardLastPart",
            label: "Kart Son 4 Hane",
            type: "text"
        },
        {
            key: "currencyId",
            label: "Para Birimi",
            type: "select",
            options: currencySelectList
        },
    ];

    return (
        <Formik
            innerRef={formref}
            initialValues={initialValues}
            // validationSchema={filtersSchema}
            onSubmit={onSubmit}
        >
            {({
                values,
                touched,
                dirty,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                handleReset,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
            }) => (
                <Form>
                    <FormObserver
                        watch={(val: any) => {
                            setFormValues(val);
                        }}
                    />
                    <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`} >
                        <div className="grid grid-cols-1 gap-3 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 ">

                            {/* <div className="flex flex-col justify-start px-0 ">
                                <div className="mt-1">
                                    <FormSelector
                                        options={customerOptions}
                                        name="customerId"
                                        label="Cari Hesap Seç"
                                        value={getSelectedValueFromId(values.customerId, customerOptions)}
                                        isSearchable
                                        isClearable
                                        isLazyFrontend
                                        lazyPageSize={50}
                                        loading={loadingCustomer}
                                    />
                                </div>
                                <div className="mt-2">
                                    <FormInput
                                        label="Cari Hesap Ünvan / Cari Kodu"
                                        name="customerNameOrCode"
                                        type="text"
                                    />
                                </div>
                                <div className="mt-2">
                                    <FormInput
                                        label="VKN/TCKN"
                                        name="taxCode"
                                        mask="99999999999"
                                        type="text"
                                    />
                                </div> 
                            </div> */}

                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormSelector
                                        options={posList}
                                        name="bankId"
                                        placeholder="Tümü"
                                        label="Ödeme Altyapısı"
                                        onChange={setFieldValue}
                                        onBlur={setFieldTouched}
                                        error={errors.bankId}
                                        touched={touched.bankId}
                                        defaultValue={formValues.bankId}
                                        value={getSelectedValueFromId(values.bankId, posList)}
                                        isDisabled={isDealer}
                                    />
                                </div>
                                <div className="mt-2">
                                    <FormInput
                                        label="Sipariş Kodu"
                                        name="orderCode"
                                        type="text"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col justify-start px-0">
                                <div className="mt-1">
                                    <FormDateSelector
                                        label="Tarih Aralığı"
                                        name="dateRange"
                                        type="range"
                                        nullable={true}
                                        ref={dateRangeRef}
                                    />
                                </div>
                                <div className="mt-2">
                                    <AmountRange
                                        label="Bakiye Aralığı"
                                        name="amountRange"
                                        type="text"
                                    />
                                </div>
                                {/* <div className="flex flex-row space-x-2 mt-2">
                                    <div className="flex-grow">
                                        <FormInput
                                            label="Kart İlk 4 Hane"
                                            name="cardFirstPart"
                                            type="text"
                                            mask="9999"
                                        />
                                    </div>
                                    <div className="flex-grow">
                                        <FormInput
                                            label="Kart Son 4 Hane"
                                            name="cardLastPart"
                                            type="text"
                                            mask="9999"
                                        />
                                    </div>
                                </div> */}
                            </div>
                            <div className="flex flex-col justify-start px-0">
                                <div className="mr-3 mt-[2.2rem]">
                                    <FormCheckbox
                                        label="Detaylı Göster"
                                        name="showDetail"
                                        id="showDetail"
                                        type="checkbox"
                                        onChange={setFieldValue}
                                        value={values.showDetail}
                                    />
                                </div>
                                <div className="mt-4">
                                    {firmInformations.isCurrency === true ? <FormSelector
                                        options={currencySelectList}
                                        label="Para Birimi"
                                        name="currencyId"
                                        type="select"
                                        onChange={setFieldValue}
                                        onBlur={setFieldTouched}
                                        error={errors.currencyId}
                                        touched={touched.currencyId}
                                        defaultValue={formValues.currencyId}
                                        value={getSelectedValueFromId(values.currencyId, currencySelectList)}
                                        isClearable
                                    /> : ""}
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end mt-2 mr-0">
                            <Button
                                type="button"
                                color="gray"
                                hover="gray"
                                size="xs"
                                className="mr-3"
                                callback={clearFilters}
                            >
                                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                                <span className='ml-3'>{buttonTexts.filterClear}</span>
                            </Button>
                            <Button type="submit" color="primary" hover="primary" size="xs">
                                <img src="/icons/prepare-white.svg" alt="prepare" />
                                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
                            </Button>
                        </div>
                    </div>
                    <div
                        className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""
                            }`}
                    >
                        <FormFiltersShortList
                            formValues={{ ...values }}
                            fields={fields}
                            initialValues={initialValues}
                            callback={(val: any) => onUpdate(val)}
                            clearFilter={() => {
                                clearFilters();
                                submitform();
                            }}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
});

export default Filters